export default __webpack_public_path__ + "static/media/howtouse_plus_04_en.472dde06.png";